var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColombia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    zoomAndPan: "magnify",
    viewBox: "0 0 60 37.5",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7c7ba545aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.164062 1.300781 L 54.273438 1.300781 L 54.273438 19 L 6.164062 19 Z M 6.164062 1.300781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f92b93ae39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.164062 18 L 54.273438 18 L 54.273438 29 L 6.164062 29 Z M 6.164062 18 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4df5046c7e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.164062 28 L 54.273438 28 L 54.273438 36.085938 L 6.164062 36.085938 Z M 6.164062 28 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7c7ba545aa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fbd116",
    d: "M 48.917969 1.300781 L 11.523438 1.300781 C 8.574219 1.300781 6.183594 3.695312 6.183594 6.652344 L 6.183594 18.691406 L 54.257812 18.691406 L 54.257812 6.652344 C 54.257812 3.695312 51.867188 1.300781 48.917969 1.300781 Z M 48.917969 1.300781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f92b93ae39)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#22408c",
    d: "M 6.183594 18.691406 L 54.257812 18.691406 L 54.257812 28.058594 L 6.183594 28.058594 Z M 6.183594 18.691406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4df5046c7e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ce2028",
    d: "M 6.183594 30.734375 C 6.183594 33.6875 8.574219 36.085938 11.523438 36.085938 L 48.917969 36.085938 C 51.867188 36.085938 54.257812 33.6875 54.257812 30.734375 L 54.257812 28.058594 L 6.183594 28.058594 Z M 6.183594 30.734375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColombia);
export default __webpack_public_path__ + "static/media/colombia.55e29a8e08551bfff5e7d15eb4047b07.svg";
export { ForwardRef as ReactComponent };